import { useEffect, useState } from "react"
import { useFormatDate } from "src/shared/hooks/useFormatDate"

function DateSection(): JSX.Element {
    const [value, setValue] = useState<string>("Cargando...")
    const { formatCustomDate } = useFormatDate()

    useEffect(() => {
        const interval = setInterval(() => {
            setValue(
                formatCustomDate(
                    new Date(),
                    "D de MMMM de YYYY\nHH:mm:ss"
                )
            )
        }, 1000)

        return () => clearInterval(interval)
    }, [formatCustomDate])

    return <p className="disp__date-section">{value}</p>
}

export default DateSection